import { useEffect, useState } from "react";
import PasswordField from "@/components/PasswordField";
import { completeReset, inspectReset } from "@/lib/siteApi";

const serif = '"Cormorant Garamond", Georgia, serif';

export default function ResetAccess() {
  const params = new URLSearchParams(window.location.search);
  const token = params.get("token") || "";
  const [ready, setReady] = useState(false);
  const [kind, setKind] = useState("");
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [error, setError] = useState("");
  const [done, setDone] = useState(false);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    document.title = "Reset akses MIJI";
    if (!token) {
      setError("Tautan reset tidak lengkap.");
      setReady(true);
      return undefined;
    }
    inspectReset(token)
      .then((result) => setKind(result.kind || ""))
      .catch((err) => setError(err.message || "Tautan reset sudah tidak berlaku."))
      .finally(() => setReady(true));
    return undefined;
  }, [token]);

  const submit = async (event) => {
    event.preventDefault();
    if (password.length < 6) {
      setError("Password minimal 6 karakter.");
      return;
    }
    if (password !== confirm) {
      setError("Password dan konfirmasi belum sama.");
      return;
    }
    setBusy(true);
    setError("");
    try {
      await completeReset({ token, password });
      setDone(true);
    } catch (err) {
      setError(err.message || "Reset gagal.");
    } finally {
      setBusy(false);
    }
  };

  const home = kind === "admin" ? "/admin" : "/";
  const label = kind === "visitor" ? "kode akses pengunjung" : "password admin";

  return (
    <div className="min-h-screen bg-[#f6f3ee] px-4 py-16 text-[#1c1917]" style={{ fontFamily: '"Manrope", Inter, sans-serif' }}>
      <form onSubmit={submit} className="mx-auto max-w-md rounded-3xl border border-[#ece6de] bg-white p-8">
        <div className="text-[11px] tracking-[0.22em] text-[#8a8178]">MIJI HAIRCARE</div>
        <h1 className="mt-2 text-4xl" style={{ fontFamily: serif }}>Reset akses</h1>
        {!ready && <p className="mt-4 text-sm text-[#6d655e]">Memeriksa tautan…</p>}
        {ready && done && (
          <>
            <p className="mt-4 text-sm text-[#4a433c]">{label} sudah diganti. Masuk dengan yang baru.</p>
            <a href={home} className="mt-6 inline-flex w-full items-center justify-center rounded-full bg-[#1c1917] py-3 text-sm text-white">
              Kembali masuk
            </a>
          </>
        )}
        {ready && !done && kind && (
          <>
            <p className="mt-3 text-sm text-[#6d655e]">Buat {label} baru. Gunakan tombol lihat password supaya tidak salah ketik.</p>
            <div className="mt-6 space-y-4">
              <PasswordField label="Password baru" value={password} onChange={(e) => setPassword(e.target.value)} autoFocus />
              <PasswordField label="Ulangi password" value={confirm} onChange={(e) => setConfirm(e.target.value)} />
            </div>
            {error && <p className="mt-3 text-sm text-rose-700">{error}</p>}
            <button type="submit" disabled={busy} className="mt-6 w-full rounded-full bg-[#1c1917] py-3 text-sm text-white disabled:opacity-50">
              {busy ? "Menyimpan…" : "Simpan password baru"}
            </button>
          </>
        )}
        {ready && !done && !kind && (
          <>
            <p className="mt-4 text-sm text-rose-700">{error || "Tautan reset sudah tidak berlaku."}</p>
            <a href="/" className="mt-6 inline-flex w-full items-center justify-center rounded-full border border-[#d9d0c6] py-3 text-sm">
              Kembali
            </a>
          </>
        )}
      </form>
    </div>
  );
}
